import {
  isEmpty,
  find,
  every,
  get,
  pipe,
  split,
  isArray,
  flatMap,
  flatten,
  forEach,
  map
} from 'lodash/fp'
import { debounce } from 'lodash'

export function vSelectWatcher(immediate) {
  return this.$watch(
    'options',
    value => {
      const noOptions = get('length', value) === 0
      const optionNotFound = !find(
        it => it.id === get('id', this.value) || it.id == this.value,
        value
      )

      if (!this.value || (this.value && (noOptions || optionNotFound))) {
        this.onInput(null)
      }
    },
    {
      immediate
    }
  )
}

export function getImageType(blob) {
  return pipe(get('type'), split('/'), get(1))(blob)
}

export function unformatDate(date) {
  const split = date.slice(0, 10).split('-')
  return `${split[2]}/${split[1]}/${split[0]}`
}

export function formatDate(date) {
  const split = date.split('/')
  return `${split[2]}-${split[1]}-${split[0]}`
}

export function handleSearch({
  searchHandler,
  searchTerm,
  loading,
  options,
  params
}) {
  if (!options.loading && searchTerm) {
    loading(true)
  }
  search(loading, searchTerm, searchHandler, params)
}

const search = debounce((loading, search, searchHandler, params) => {
  searchHandler({
    ...params,
    search: escape(search)
  }).then(() => loading(false))
}, 350)

export function validateFieldState({ validation, field, form, optional }) {
  const isSubmitted = get('form.submitted', validation)

  if (!isSubmitted || !mustValidate({ field, optional, form })) {
    return null
  }

  return isArray(get(['state', field], validation))
    ? pipe(
        get(['state', field]),
        every(it => Boolean(it.isValid))
      )(validation)
    : Boolean(get(['state', field, 'isValid'], validation))
}

export function isFieldInvalid({ validation, field }) {
  return (
    get('form.submitted', validation) &&
    !validateFieldState({ validation, field })
  )
}

export function isValidEmail(email) {
  let regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return regex.test(String(email).toLowerCase())
}

export function isFormValid(state) {
  return pipe(
    flatMap(it => it),
    flatten,
    every(it => Boolean(it.isValid))
  )(state)
}

export function getValidation({ form, fields, submitted }) {
  let state = {}

  pipe(
    forEach(it => {
      state[it.key] = map(
        validator => ({
          isValid: validator.isValid(form[it.key], form),
          message: validator.message
        }),
        it.validators
      )
    })
  )(fields)

  return {
    state,
    form: {
      submitted,
      isValid: isFormValid(state)
    }
  }
}

export function getValidationClass({ validation }) {
  const isInvalid = isFieldInvalid({ validation, field: validation.field })
  return get('form.submitted', validation)
    ? {
        'is-invalid': isInvalid,
        'is-valid': !isInvalid
      }
    : null
}

export function mustValidate({ field, form, optional }) {
  return !optional || (optional && !isEmpty(get(field, form)))
}

export function clearSpace(str) {
  return str.replace(/\s/g, '')
}
